<template>
  <div>
    <b-row>
      <b-col md="6">
        <McAlert :text="$t('setting.autoComplete.alert')" variant="info" withIcon />
        <div class="d-flex gap-3 mt-3 mb-3">
          <McCheckbox v-model="isAutoCompleteOn" />
          <div>
            <p class="fw-bold">{{ $t('setting.autoComplete.label') }}</p>
            <p v-html="$t('setting.autoComplete.info')" />
            <div v-if="isAutoCompleteOn">
              <label>{{ $t('setting.autoComplete.dropdownLabel') }}</label>
              <Multiselect
                track-by="value"
                label="label"
                v-model="autoCompleteSource"
                :options="options"
                disabled
              >
                <template #option="{ option }">
                  <div class="d-flex justify-content-between">
                    <span>{{ option.value }}</span>
                    <span v-if="option.isDefault && autoCompleteSource?.value !== option.value">{{
                      'Default'
                    }}</span>
                  </div>
                </template>
              </Multiselect>
            </div>
          </div>
        </div>
        <div v-if="hasAutoCompleteSettingChanged" class="d-flex align-items-center gap-3">
          <McButton
            :text="$t('global.cancel')"
            variant="secondary"
            icon="icon-outline_close"
            @click="handleCancel"
            :disabled="isLoading"
          />
          <McButton
            :text="$t('global.save')"
            icon="icon-outline_save"
            @click="handleSave"
            :disabled="isLoading"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'
import McCheckbox from '@/components/McCheckbox'
import * as Setting from '@/services/rest-api/lib/fleet-task/setting'
import Multiselect from 'vue-multiselect'
import isEqual from 'lodash/isEqual'
import pick from 'lodash/pick'

const options = [
  { label: 'GPS Kendaraan', value: 'GPS Kendaraan', isDefault: true },
  { label: 'Smart Driver', value: 'Smart Driver' },
]

export default {
  components: {
    McButton,
    Multiselect,
    McAlert,
    McCheckbox,
  },
  inject: ['setting', 'getUserSetting'],
  data() {
    return {
      autoCompleteSource: options[0],
      isAutoCompleteOn: false,
      options,
      initialSetting: null,
      isLoading: false,
    }
  },
  computed: {
    hasAutoCompleteSettingChanged() {
      if (!this.initialSetting) {
        return false
      }

      return !isEqual(pick(this.initialSetting, ['autocomplete_source', 'is_autocomplete_on']), {
        autocomplete_source: this.autoCompleteSource.value,
        is_autocomplete_on: this.isAutoCompleteOn,
      })
    },
  },
  watch: {
    setting: {
      immediate: true,
      handler(value) {
        if (!value) return
        this.initialSetting = value
        this.setAutocompleteSetting(value)
      },
    },
  },
  methods: {
    async handleSave() {
      this.isLoading = true

      const res = await Setting.update({
        autocomplete_source: this.autoCompleteSource.value,
        is_autocomplete_on: this.isAutoCompleteOn,
      })

      if (res.errors) return

      this.$mcToast.success(this.$t('global.alert.text.saved'))

      await this.getUserSetting()

      this.isLoading = false
    },
    handleCancel() {
      this.setAutocompleteSetting(this.initialSetting)
    },
    setAutocompleteSetting(setting) {
      this.autoCompleteSource =
        this.options.find((option) => option.value === setting.autocomplete_source) ?? null
      this.isAutoCompleteOn = setting.is_autocomplete_on
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.mc-alert) {
  align-items: center;
  max-width: 100%;
  height: auto;

  .mc-alert__text {
    margin: 0;
  }
}

:deep(.multiselect) {
  min-height: auto;

  .multiselect__select {
    height: auto;
    bottom: 1px;
    top: 1px;

    &::before {
      top: 63% !important;
      margin: 0;
    }
  }
}
</style>
